import { useEffect } from 'react';

// Native "leave site?" confirmation for accidental reload/close/back — this
// is the one browser-level hook that fires for all of those (not just
// in-app navigation, which is already guarded separately where needed).
// Browsers ignore any custom message and show their own fixed wording; both
// preventDefault() and returnValue are required for cross-browser support.
export function useBeforeUnloadWarning(shouldWarn) {
    useEffect(() => {
        if (!shouldWarn) return undefined;
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [shouldWarn]);
}
